module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ChatRoom"
    }
  }, [(!_vm.livetimeend && _vm.directStatus != 'running') ? _c('div', {
    staticStyle: {
      "height": "84px"
    }
  }, [_c('div', {
    staticClass: "countDown"
  }, [_c('p', [_vm._v("直播倒计时")]), _vm._v(" "), _c('ul', {
    staticClass: "times"
  }, [_c('li', [_vm._v("\n            " + _vm._s(_vm.days) + "\n            "), _c('span', [_vm._v("天")])]), _vm._v(" "), _c('li', [_vm._v("\n            " + _vm._s(_vm.hours) + "\n            "), _c('span', [_vm._v("时")])]), _vm._v(" "), _c('li', [_vm._v("\n            " + _vm._s(_vm.minites) + "\n            "), _c('span', [_vm._v("分")])]), _vm._v(" "), _c('li', [_vm._v("\n            " + _vm._s(_vm.seconds) + "\n            "), _c('span', [_vm._v("秒")])])])])]) : _vm._e(), _vm._v(" "), (_vm.noticeObj.open && _vm.isNoitceTopShow) ? _c('div', {
    staticStyle: {
      "height": "36px"
    }
  }, [_c('div', {
    staticClass: "noticeBox"
  }, [_c('van-notice-bar', {
    staticClass: "noticeBar",
    attrs: {
      "text": _vm.noticeObj.content
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right-func-box"
  }, [((_vm.businessConfigs && (_vm.businessConfigs.student_room_link_mic_show || _vm.businessConfigs.student_room_link_mic_show == undefined)) &&
    _vm.initData.direct_seeding.play_style == 3 && _vm.initData.direct_seeding.direct_status == 'running' && _vm.playerStatus == 2) ? _c('div', {
    staticClass: "link-btn"
  }, [(_vm.linkType != 3) ? _c('img', {
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/lianmai.png"
    },
    on: {
      "click": _vm.onLinkCLick
    }
  }) : _vm._e(), _vm._v(" "), (_vm.linkType == 3) ? _c('img', {
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/lianmaizhong.png"
    },
    on: {
      "click": _vm.onLinkEndClick
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.onLinkEndClick
    }
  }, [_vm._v("连麦互动")])]) : _vm._e(), _vm._v(" "), (_vm.isshowCart) ? _c('div', {
    staticClass: "zixun-btn"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../statics/imgs/cart-Empty.png")
    },
    on: {
      "click": _vm.onShowGoodsList
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.onShowGoodsList
    }
  }, [_vm._v("购物车")])]) : _vm._e(), _vm._v(" "), (_vm.showTeacherBtn && (!_vm.userConfig || (_vm.userConfig && _vm.userConfig.show_teacher != 0))) ? _c('div', {
    staticClass: "zixun-btn"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../statics/imgs/zixun_icon.png")
    },
    on: {
      "click": _vm.onShowTeacherList
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.onShowTeacherList
    }
  }, [_vm._v("咨询老师")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.unReadMsgPointShow),
      expression: "unReadMsgPointShow"
    }],
    staticClass: "unReadMsgPoint"
  })]) : _vm._e(), _vm._v(" "), (_vm.openWx_follow) ? _c('div', {
    staticClass: "zixun-btn"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../statics/imgs/guanzhu_icon.png")
    },
    on: {
      "click": function($event) {
        return _vm.$emit('onShowFouceAlert')
      }
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.onShowTeacherList
    }
  }, [_vm._v("关注+")])]) : _vm._e()]), _vm._v(" "), (_vm.showUnReadView) ? _c('div', {
    ref: "unReadMessageView",
    staticClass: "unReadView unReadViewShowAni",
    on: {
      "click": _vm.onShowTeacherList
    }
  }, [(_vm.unReadMsgData) ? _c('img', {
    staticClass: "header",
    attrs: {
      "src": _vm.unReadMsgData.header
    }
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.unReadMsgData ? _vm.unReadMsgData.content : "") + "\n    "), _c('i', {
    staticClass: "sanjiao"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "ChatRoomContent"
    },
    on: {
      "scroll": _vm.chatScroll,
      "touchstart": _vm.chatTouchstart,
      "touchmove": _vm.chatTouchmove,
      "touchend": _vm.chatTouchend
    }
  }, [_c('van-pull-refresh', {
    staticClass: "ChatRoom-body",
    attrs: {
      "id": "ChatRoom-bodyId"
    },
    on: {
      "refresh": _vm.loadMore
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [(_vm.chatRecord.length) ? [_vm._l((_vm.chatRecord), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cell"
    }, [_c('div', {
      staticClass: "comment_cell",
      class: {
        hostman: item.fans_id == _vm.hostId && item.module != 'wall_comment',
        type: _vm.styleType == 3,
      }
    }, [_c('div', {
      staticClass: "header"
    }, [(item.module != 'wall_comment') ? [(item.fans_id == _vm.hostId) ? _c('div', {
      staticClass: "msg_header"
    }, [_c('img', {
      staticClass: "headimg",
      attrs: {
        "src": item.header
      }
    }), _vm._v(" "), (_vm.styleType != 3) ? _c('img', {
      staticClass: "rank",
      attrs: {
        "src": _vm.imgPath + 'room/zhuchiren1.png'
      }
    }) : _c('img', {
      staticClass: "rank",
      attrs: {
        "src": _vm.imgPath + 'room/zhuchiren3.png'
      }
    })]) : _c('div', {
      staticClass: "msg_header"
    }, [_c('img', {
      staticClass: "headimg",
      attrs: {
        "src": item.header
      }
    })])] : [_c('div', {
      staticClass: "msg_header"
    }, [_c('img', {
      staticClass: "occupyRank",
      attrs: {
        "src": _vm.imgPath + 'room/headImg-bg.png'
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "headimg",
      attrs: {
        "src": item.header
      }
    })])], _vm._v(" "), _c('div', {
      staticClass: "nameTime"
    }, [_c('div', {
      staticClass: "floor_name",
      staticStyle: {
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "white-space": "nowrap"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px",
        "line-height": "20px",
        "max-width": "200px"
      },
      style: ({
        color: item.to_fans_id ? '#027DB4' : '#444444'
      })
    }, [_vm._v(_vm._s(_vm.changeNick(item.nick)))]), _vm._v(" "), (item.showzhu == 1) ? _c('span', {
      staticClass: "zhuTeacher"
    }, [_vm._v("老师")]) : _vm._e(), _vm._v(" "), (item.to_fans_id) ? _c('span', {
      staticClass: "teacher_replay_text"
    }, [_vm._v("回复你")]) : _vm._e(), _vm._v(" "), (!(_vm.userConfig && _vm.userConfig.showCommentTime === 0)) ? _c('span', {
      staticStyle: {
        "font-size": "10px",
        "line-height": "20px",
        "margin-left": "5px"
      }
    }, [_vm._v(_vm._s(item.create_time))]) : _vm._e()])])], 2), _vm._v(" "), (item.module == 'text_comment' && item.fans_id == _vm.hostId) ? _c('div', {
      staticClass: "msg_conent"
    }, [_c('p', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (item.content),
        expression: "item.content"
      }]
    }), _vm._v(" "), (item.pic_url && item.content) ? _c('div', {
      staticStyle: {
        "height": "10px"
      }
    }) : _vm._e(), _vm._v(" "), (item.pic_url) ? _c('img', {
      staticClass: "contImg",
      attrs: {
        "src": item.pic_url
      },
      on: {
        "click": function($event) {
          return _vm.preview(item.pic_url)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "xinxin1",
      attrs: {
        "src": _vm.imgPath + 'room/xinxin1_03.png'
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "xinxin2",
      attrs: {
        "src": _vm.imgPath + 'room/xinxin2_03.png'
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "xinxin3",
      attrs: {
        "src": _vm.imgPath + 'room/fff_03.png'
      }
    })]) : (
      item.module == 'text_comment' && item.fans_id != _vm.hostId
    ) ? _c('div', {
      staticClass: "comment-text"
    }, [_c('p', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (item.content),
        expression: "item.content"
      }],
      staticStyle: {
        "font-size": "13px",
        "word-break": "break-all",
        "white-space": "pre-line"
      }
    }), _vm._v(" "), (item.pic_url && item.content) ? _c('div', {
      staticStyle: {
        "height": "10px"
      }
    }) : _vm._e(), _vm._v(" "), (item.pic_url) ? _c('img', {
      staticClass: "contImg",
      attrs: {
        "src": item.pic_url
      },
      on: {
        "click": function($event) {
          return _vm.preview(item.pic_url)
        }
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((item.sublist), function(sublist, index) {
      return _c('div', {
        key: index,
        staticClass: "sublist"
      }, [_c('div', {
        staticClass: "title clearfix"
      }, [_c('span', {
        staticClass: "fl"
      }, [_vm._v(_vm._s(sublist.nick))]), _vm._v(" "), _c('span', {
        staticClass: "fr time"
      }, [_vm._v(_vm._s(sublist.create_time.substr(5, sublist.create_time.length)))])]), _vm._v(" "), _c('p', {
        directives: [{
          name: "dompurify-html",
          rawName: "v-dompurify-html",
          value: (sublist.content),
          expression: "sublist.content"
        }]
      })])
    }), _vm._v(" "), (item.showcopytext) ? _c('span', {
      staticClass: "copyText",
      on: {
        "click": function($event) {
          return _vm.copyTextTap(item.content)
        }
      }
    }, [_vm._v("复制")]) : _vm._e()], 2) : (item.module == 'notice') ? _c('div', {
      staticClass: "comment-text"
    }, [_c('p', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (item.content),
        expression: "item.content"
      }],
      staticStyle: {
        "font-size": "13px",
        "word-break": "break-all"
      }
    })]) : (item.module == 'redpack_comment') ? _c('div', {
      staticClass: "red-pack",
      on: {
        "click": function($event) {
          return _vm.robRedBagAction(item)
        }
      }
    }, [_c('div', {
      staticClass: "red-pack-header"
    }, [_c('img', {
      staticClass: "red-pack-img",
      attrs: {
        "src": _vm.imgPath + 'room/redpack_03.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "red-pack-title"
    }, [(item.content) ? _c('p', {
      staticClass: "ellipsis"
    }, [_vm._v("\n                    " + _vm._s(item.content) + "\n                  ")]) : _c('p', [_vm._v("恭喜发财，大吉大利")]), _vm._v(" "), _c('p', {
      staticClass: "red-pack-desc"
    }, [_vm._v("拼手气红包，先到先得")])])]), _vm._v(" "), _c('div', {
      staticClass: "red-pack-body"
    }, _vm._l((item.sublist), function(redpack, index) {
      return _c('div', {
        key: index,
        staticClass: "red-pack-item clearfix"
      }, [_c('span', {
        staticClass: "red-pack-item-name fl"
      }, [_vm._v(_vm._s(redpack.nick) + "：")]), _vm._v(" "), _c('span', {
        staticClass: "red-pack-item-money"
      }, [_vm._v("￥" + _vm._s(redpack.total_money / 100))]), _vm._v(" "), _c('span', {
        staticClass: "red-pack-item-time fr"
      }, [_vm._v(_vm._s(redpack.create_time.split(" ")[1]))])])
    }), 0)]) : (item.module == 'reward_redpacket_comment') ? _c('div', {
      staticClass: "red-pack"
    }, [_c('div', {
      staticClass: "red-pack-header"
    }, [_c('img', {
      staticClass: "red-pack-img",
      attrs: {
        "src": _vm.imgPath + 'room/redpack_03.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "red-pack-title"
    }, [(item.content) ? _c('p', {
      staticClass: "ellipsis"
    }, [_vm._v("\n                    " + _vm._s(item.content) + "\n                  ")]) : _c('p', [_vm._v("恭喜发财，大吉大利")]), _vm._v(" "), (_vm.ds_id != 194) ? _c('p', {
      staticClass: "red-pack-desc ellipsis"
    }, [_vm._v("\n                    向主办方打赏了一个" + _vm._s(item.total_money / 100) + "元的红包\n                  ")]) : _c('p', {
      staticClass: "red-pack-desc ellipsis"
    }, [_vm._v("\n                    向主演打赏了一个" + _vm._s(item.total_money / 100) + "元的红包\n                  ")])])])]) : (item.module == 'share_comment') ? _c('div', {
      staticClass: "red-pack"
    }, [_c('div', {
      staticClass: "red-pack-header"
    }, [_c('img', {
      staticClass: "red-pack-img",
      attrs: {
        "src": _vm.imgPath + 'room/redpack_03.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "red-pack-title"
    }, [_c('p', {
      staticClass: "share_red_content ellipsis"
    }, [_vm._v("\n                    " + _vm._s(item.nick) + "分享后得到" + _vm._s(item.money / 100) + "元的红包\n                  ")])])])]) : (item.module == 'invite_comment') ? _c('div', {
      staticClass: "red-pack"
    }, [_c('div', {
      staticClass: "red-pack-header"
    }, [_c('img', {
      staticClass: "red-pack-img",
      attrs: {
        "src": _vm.imgPath + 'room/redpack_03.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "red-pack-title"
    }, [_c('p', {
      staticClass: "share_red_content ellipsis"
    }, [_vm._v("\n                    " + _vm._s(item.nick) + "获得" + _vm._s(item.money / 100) + "元的红包\n                  ")])])]), _vm._v(" "), _c('p', {
      staticClass: "caption"
    }, [_c('span', [_vm._v(_vm._s(item.invite_nick))]), _vm._v("通过 "), _c('span', [_vm._v(_vm._s(item.nick))]), _vm._v("分享的直播链接进入\n              ")])]) : (item.module == 'gift_comment') ? _c('div', {
      staticClass: "comment-text"
    }, [_c('p', [_vm._v("\n                赠送了：\n                "), _c('img', {
      staticClass: "gift",
      attrs: {
        "src": item.gift_pic_url
      }
    }), _vm._v("\n                x " + _vm._s(item.gift_num ? item.gift_num : 1) + "\n              ")])]) : (item.module == 'wall_comment') ? _c('div', {
      staticClass: "comment-text wall_comment"
    }, [(item.content) ? _c('p', [_c('span', [_vm._v("重金霸屏" + _vm._s(5 * item.pay_level) + "秒：")]), _vm._v("\n                " + _vm._s(item.content) + "\n              ")]) : _vm._e(), _vm._v(" "), (item.pic_url && item.content) ? _c('div', {
      staticStyle: {
        "height": "10px"
      }
    }) : _vm._e(), _vm._v(" "), (item.pic_url) ? _c('img', {
      staticClass: "contImg",
      attrs: {
        "src": item.pic_url
      },
      on: {
        "click": function($event) {
          return _vm.preview(item.pic_url)
        }
      }
    }) : _vm._e()]) : (item.module == 'coupon_comment') ? _c('div', {
      staticClass: "comment-text quanBox",
      style: ('background-image:url(' + _vm.imgPath + 'room/quan-bg.png)')
    }, [_c('div', {
      staticClass: "quan"
    }, [(item.coupon_type == 'discount') ? _c('div', {
      staticClass: "quantype"
    }, [_vm._v("\n                  折扣券\n                ")]) : (item.coupon_type == 'money') ? _c('div', {
      staticClass: "quantype"
    }, [_vm._v("\n                  代金券\n                ")]) : (item.coupon_type == 'gift') ? _c('div', {
      staticClass: "quantype"
    }, [_vm._v("\n                  礼品券\n                ")]) : (item.coupon_type == 'coupon') ? _c('div', {
      staticClass: "quantype"
    }, [_vm._v("\n                  优惠券\n                ")]) : _c('div', {
      staticClass: "quantype"
    }, [_vm._v("门票券")]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(item.coupon_title))])])]), _vm._v(" "), (item.invite_nick) ? _c('p', {
      staticClass: "caption"
    }, [_c('span', [_vm._v(_vm._s(item.invite_nick))]), _vm._v("通过 "), _c('span', [_vm._v(_vm._s(item.nick))]), _vm._v("分享的直播链接进入\n              ")]) : _vm._e()]) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })] : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingShow),
      expression: "loadingShow"
    }],
    staticClass: "loading"
  }, [_c('van-loading', {
    attrs: {
      "color": "black"
    }
  })], 1), _vm._v(" "), (!_vm.isThreeScreen) ? _c('div', {
    staticStyle: {
      "height": "40px",
      "width": "100%",
      "text-align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.livetimeend && _vm.directStatus != 'running') ? _c('div', {
    staticStyle: {
      "height": "84px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.noticeObj.open && _vm.isNoitceTopShow) ? _c('div', {
    staticStyle: {
      "height": "36px"
    }
  }) : _vm._e()], 2)], 1), _vm._v(" "), _vm._l((_vm.lovestyle[0]), function(n, index) {
    return _c('div', {
      key: index,
      staticClass: "zan-box",
      style: (n)
    }, [_c('img', {
      staticClass: "zan-img",
      attrs: {
        "src": _vm.zanimg[0]
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.lovestyle[1]), function(n, index) {
    return _c('div', {
      key: index,
      staticClass: "zan-box",
      style: (n)
    }, [_c('img', {
      staticClass: "zan-img",
      attrs: {
        "src": _vm.zanimg[2]
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.lovestyle[2]), function(n, index) {
    return _c('div', {
      key: index,
      staticClass: "zan-box",
      style: (n)
    }, [_c('img', {
      staticClass: "zan-img",
      attrs: {
        "src": _vm.zanimg[3]
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.lovestyle[3]), function(n, index) {
    return _c('div', {
      key: index,
      staticClass: "zan-box",
      style: (n)
    }, [_c('img', {
      staticClass: "zan-img",
      attrs: {
        "src": _vm.zanimg[4]
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.lovestyle[4]), function(n, index) {
    return _c('div', {
      key: index,
      staticClass: "zan-box",
      style: (n)
    }, [_c('img', {
      staticClass: "zan-img",
      attrs: {
        "src": _vm.zanimg[5]
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.lovestyle[5]), function(n, index) {
    return _c('div', {
      key: index,
      staticClass: "zan-box",
      style: (n)
    }, [_c('img', {
      staticClass: "zan-img",
      attrs: {
        "src": _vm.zanimg[6]
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.lovestyle[6]), function(n, index) {
    return _c('div', {
      key: index,
      staticClass: "zan-box",
      style: (n)
    }, [_c('img', {
      staticClass: "zan-img",
      attrs: {
        "src": _vm.zanimg[7]
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.lovestyle[7]), function(n, index) {
    return _c('div', {
      key: index,
      staticClass: "zan-box",
      style: (n)
    }, [_c('img', {
      staticClass: "zan-img",
      attrs: {
        "src": _vm.zanimg[8]
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.lovestyle[8]), function(n, index) {
    return _c('div', {
      key: index,
      staticClass: "zan-box",
      style: (n)
    }, [_c('img', {
      staticClass: "zan-img",
      attrs: {
        "src": _vm.zanimg[9]
      }
    })])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowUnReadMsg),
      expression: "isShowUnReadMsg"
    }],
    staticClass: "unreadMsg",
    on: {
      "click": function($event) {
        return _vm.unReadMsgAction()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'room/unreadMsg.png',
      "width": "8px",
      "height": "8px"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0 0 0 5px"
    }
  }, [_vm._v(_vm._s(_vm.unReadMsgNum) + "条新消息")])]), _vm._v(" "), (_vm.numList.length) ? _c('div', {
    staticClass: "zanBox"
  }, _vm._l((_vm.numList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "num"
    }, [_vm._l((item), function(item1) {
      return [_c('img', {
        key: item1,
        attrs: {
          "src": item1,
          "alt": "index"
        }
      })]
    })], 2)
  }), 0) : _vm._e(), _vm._v(" "), _c('van-popup', {
    staticClass: "codebox",
    model: {
      value: (_vm.showCode),
      callback: function($$v) {
        _vm.showCode = $$v
      },
      expression: "showCode"
    }
  }, [_c('div', [_c('p', {
    staticClass: "title"
  }, [_vm._v("长按关注公众号")]), _vm._v(" "), _c('img', {
    staticClass: "code stop",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/code/code.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("关注二维码，了解最新直播信息")])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e265ae4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/menu/ChatRoom.vue
// module id = 229
// module chunks = 0